import React from 'react';
import Page from 'components/Page';
import S3DownloadLink from 'components/S3DownloadLink';
import { useHasura } from 'context/ApiState';
import { ReactComponent as FactsheetsIcon } from 'assets/icons/icon-library.svg';
import { ReactComponent as DownloadIcon } from 'assets/icons/icon-cloud-download.svg';
import { motion } from 'framer-motion';

export default function FactSheets() {
  const { app_user } = useHasura();

  return (
    <Page
      title={`Fact Sheets ${
        app_user?.selected_organisation?.name
          ? 'for ' + app_user?.selected_organisation?.name
          : ''
      }`}
      icon={
        <FactsheetsIcon className="inline w-10 h-10 mr-2 -mb-1 -ml-2 text-gray-500" />
      }
    >
      <div className="flex flex-wrap">
        {app_user?.selected_organisation?.banks?.map((bank) =>
          bank.bank.bank_factsheets?.map(({ upload, factsheetDate }, i) => (
            <S3DownloadLink key={i} s3_key={upload?.s3_key}>
              <motion.div
                className="flex flex-col items-center justify-between w-48 mt-6 mr-6 overflow-hidden bg-contain border border-gray-400 rounded shadow-sm h-60 bg-jcap-100 hover:shadow-md"
                whileHover={{ scale: 1.02 }}
                style={{
                  backgroundImage: 'url("/ReportHeaderBlue.png")',
                }}
              >
                <div className="flex items-start justify-end w-full h-48 bg-jcapFrost-100">
                  <DownloadIcon className="w-10 h-10 p-1 m-2 rounded-full text-jcap-400 bg-frost-800" />
                </div>
                <div className="w-full p-4 font-semibold text-gray-800 bg-white border-t">
                  {bank?.bank?.image?.public_url && (
                    <img
                      src={bank?.bank?.image?.public_url}
                      className="w-20 mb-4"
                      alt={bank?.bank?.name}
                    />
                  )}
                  <h2>{bank?.bank?.name}</h2>
                  <div className="text-sm">{factsheetDate}</div>
                </div>
              </motion.div>
            </S3DownloadLink>
          )),
        )}
      </div>
    </Page>
  );
}
